import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import HaredimStatic from './HaredimStatic';

const Haredim = () => (
  <ServicePageShell strapiApiId="service-haredim" defaultTitle="Haredim" StaticFallback={HaredimStatic} />
);

export default Haredim;
